import {
  Autocomplete,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { env, url } from "../MainPage/MainPage";

const useCreateCompany = () => {
  const unitKeyBox = window.location.href.split("nps/")[1];
  const [units, handleUnits] = useState([]);
  const [selectedUnit, handleSelectedUnit] = useState("");
  const [loading, handleLoading] = useState(false);

  const reloadPage = () => window.location.reload();

  const onSubmitNewBoxUnit = async () => {
    const form = {
      box_covers_unit_id: selectedUnit.value,
      box_key: unitKeyBox,
    };
    try {
      handleLoading(true);
      const response = await axios.post(`${url[env]}/create-box`, form);
      if (response.status === 201) {
        alert("Box criado com sucesso.");
        reloadPage();
      }
    } catch (error) {
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    const getUnitsOptions = async () => {
      const response = await axios.get(`${url[env]}/options`);
      if (response.data.length > 0) {
        handleUnits(response.data);
      }
    };
    getUnitsOptions();
  }, []);
  return {
    units,
    selectedUnit,
    reloadPage,
    handleSelectedUnit,
    onSubmitNewBoxUnit,
    loading,
  };
};

const CreateCompany = (props) => {
  const {
    handleSelectedUnit,
    selectedUnit,
    units,
    onSubmitNewBoxUnit,
    loading,
  } = useCreateCompany();
  const { goBack } = props;
  return (
    <Container maxWidth="lg">
      <Button
        sx={{ marginTop: "24px" }}
        variant="outlined"
        color="secondary"
        onClick={goBack}
      >
        Voltar
      </Button>
      <Grid>
        <Typography variant="h3" marginBottom={12}>
          Configurar novo dispositivo
        </Typography>
      </Grid>
      <Paper sx={{ padding: 4 }}>
        <Grid container>
          <Grid item>
            <Autocomplete
              fullWidth
              value={selectedUnit}
              onChange={(event, newValue) => {
                handleSelectedUnit(newValue);
              }}
              options={units}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField key={params.value} {...params} label="Unidade" />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} justifyContent="flex-end" paddingTop={2}>
          <Grid item>
            <Button variant="outlined" color="warning" onClick={goBack}>
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={onSubmitNewBoxUnit}
              disabled={loading}
            >
              {loading ? "Carregando..." : "Salvar"}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default CreateCompany;
